export default __webpack_public_path__ + "static/media/12.44dfff40.jpeg";